<nb-card status="{{ status() }}">
  <nb-card-header>
    {{ quiz.title }}
  </nb-card-header>
  <nb-card-body [nbSpinner]="loading" nbSpinnerStatus="info">
    <ngx-view-quiz [quiz]="quiz"> </ngx-view-quiz>
  </nb-card-body>

  <nb-card-footer *ngIf="!loading">
    <button
      nbButton
      hero
      shape="semi-round"
      status="success"
      (click)="submit()"
      [disabled]="submitted"
      [class.btn-pulse]="submitted"
      *ngIf="!this.quiz.submitted"
    >
      <nb-icon icon="done-all-outline"></nb-icon>
      Gửi đáp án
    </button>

    <button
      nbButton
      outline
      shape="semi-round"
      status="info"
      (click)="reload()"
      [disabled]="submitted"
      [class.btn-pulse]="submitted"
      *ngIf="this.isTestQuiz && this.quiz.submitted"
    >
      <nb-icon icon="refresh-outline"></nb-icon>
      Thử lại
    </button>

    <button
      nbButton
      hero
      shape="semi-round"
      status="info"
      (click)="next()"
      [disabled]="submitted"
      [class.btn-pulse]="submitted"
      *ngIf="!this.isTestQuiz && this.quiz.submitted && !this.lastQuiz"
    >
      <nb-icon icon="arrow-forward-outline"></nb-icon>
      Câu tiếp theo
    </button>

    <button
      nbButton
      hero
      shape="semi-round"
      status="danger"
      (click)="finish()"
      [disabled]="submitted"
      [class.btn-pulse]="submitted"
      *ngIf="!this.isTestQuiz && this.quiz.submitted && this.lastQuiz"
    >
      <nb-icon icon="arrow-forward-outline"></nb-icon>
      Hoàn thành
    </button>
  </nb-card-footer>
</nb-card>
